<template>
  <div class="category">
    <div class="heading" @click="handleDropDownClick">
      <h4 class="title">
        {{ filtername === "Status" ? "Approver Status" : filtername }}
      </h4>
      <span
        :class="configuration[filtername].expanded ? 'up-arrow' : 'down-arrow'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="inherit"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.585 8.58496L12 13.17L7.415 8.58496L6 9.99996L12 16L18 9.99996L16.585 8.58496Z"
            fill="inherit" />
        </svg>
      </span>
    </div>
    <div
      v-if="configuration[filtername].expanded"
      class="content"
      :class="classname">
      <Checkbox
        v-for="(item, index) in configuration[filtername].options"
        :id="index"
        :key="index"
        :value="item.value"
        :label="item.label"
        :checked="filter && filter.indexOf(item.value) > -1"
        :onchange="checkboxHandleChange" />
    </div>
  </div>
</template>

<script>
// Components
import Checkbox from "@/components/Checkbox/Checkbox";

export default {
  name: "CheckboxFilter",
  components: {
    Checkbox,
  },
  props: {
    filtername: {
      type: String,
      required: true,
    },
    filter: {
      type: Array,
      default: () => [],
    },
    configuration: {
      type: Object,
      required: true,
    },
    classname: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleDropDownClick() {
      this.$emit("handleFilterToggle", `${this.filtername}`);
    },
    checkboxHandleChange(event) {
      this.$emit("handleFilterChange", {
        type: "checkbox",
        filterName: this.filtername,
        value: event.target.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-direction: column;
  width: 196px;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  padding: 12px;

  &-display {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &-title {
      margin: 0;
      font-size: 14px;
      font-family: "MaerskText Regular";
      color: #000000;
    }

    &-up-arrow {
      transform: rotate(180deg);
    }
  }

  &-contents {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 8px;
  }
}
.scroll {
  overflow-y: scroll;
}
</style>
